import * as React from 'react';
import * as styles from './ChoiceGroup.css';
import "../../styles/BasicIA.css";

export interface IAChoiceGroupState {
  selectedKey: string;
}

export interface ChoiceOptions {
  key: string;
  text: string;
  disabled?: boolean;
}

export interface IAChoiceGroupProps {
  label?: string;
  style?: React.CSSProperties;
  options: ChoiceOptions[];
  className?: string;
  selectedKey: string;
  highlightColor: string;
  required: boolean;
  onChange: (key) => void;
}

export class IAChoiceGroup extends React.Component<IAChoiceGroupProps, IAChoiceGroupState> {
  private radioInputRef: React.RefObject<HTMLInputElement>;

  constructor(props: IAChoiceGroupProps) {
    super(props);
    this.state = {
      selectedKey: props.selectedKey
    }
    this.radioInputRef = React.createRef();
  }

  public componentWillReceiveProps(props: IAChoiceGroupProps): void {
    this.setState({ selectedKey: props.selectedKey });
  }

  public render(): JSX.Element {
    let data = this.props.options;
    return (
      <div
        className={this.props.className}
        style={this.props.style}
      >
        <div>
          {this.props.label}
        </div>
        {data.map(option => {
          let choiceGroupBorderColor = "#cccccc";
          if (option.key === this.state.selectedKey) {
            choiceGroupBorderColor = this.props.highlightColor;
          }
          if (option.disabled) {
            choiceGroupBorderColor = "#eeeeee";
          }
          return (
            <div
              key={option.key}
              className={styles.IA_ChoiceGroup}
              style={{
                color: option.disabled ? "#cccccc" : "#333333",
                marginTop: 3
              }}
            >
              <label className={styles.container}>
                <input
                  tabIndex={-1}
                  ref={this.radioInputRef}
                  type='Radio'
                  checked={option.key === this.state.selectedKey}
                  onChange={() => {
                    this.setState({ selectedKey: option.key }, () => {
                      this.props.onChange(option.key);
                    });
                  }}
                  disabled={option.disabled}
                />
                <span
                  tabIndex={0}
                  className={[styles.checkmark, "IA_OnMouseFocusOutline"].join(" ")}
                  style={{
                    border: `5px solid ${choiceGroupBorderColor}`
                  }}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      this.radioInputRef.current.click();
                    }
                  }}
    
                />
                {option.text}
              </label>
            </div>
          );
        })}
      </div>
    );
  }
}

